import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import ExclamationIcon from '../icons/ExclamationIcon';
import sizes from './sizes';
const HazardButton = ({ disabled, onClick, title, id, className, size }) => (React.createElement(CircleButton, { id: id, size: size, className: className, color: "yellow", disabled: disabled, onClick: onClick, title: title },
    React.createElement(ExclamationIcon, { className: "w-6 h-6" })));
HazardButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    title: PropTypes.string,
};
HazardButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
    onClick: () => { },
};
export default HazardButton;
